import React from 'react';

import './Counter.scss';

import IconLess from '../../../../static/images/icons/less.svg';
import IconMore from '../../../../static/images/icons/more.svg';
import { CartController } from "../../../../helpers/CartController";

const Counter = ({item, setCart}) => {
  const appendItem = () => {
    const resp = CartController.appendToCart(item.id, 1, item.stockQuantity, 'en');
    setCart(resp);
  }

  const removeItem = () => {
    const resp = CartController.appendToCart(item.id, -1, item.stockQuantity, 'en');
    setCart(resp);
  }
  return (
    <div className="counter">
      <button className="decrease" type="button" onClick={removeItem}>
        <img src={IconLess} alt="Menos" />
      </button>

      <div className="quantity">{item.quantity}</div>

      <button className="increase" type="button" onClick={appendItem}>
        <img src={IconMore} alt="Más" />
      </button>
    </div>
  );
};

export default Counter;
